(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ee-collection-details"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.collectionDescriptionClamp) return;
    window.collectionDescriptionClamp = true;

    function overflows(text) {
      var wasCollapsed = text.classList.contains('is-collapsed');
      text.classList.add('is-collapsed');
      var maxHeight = window.getComputedStyle(text).maxHeight;
      if (maxHeight === 'none') {
        if (!wasCollapsed) text.classList.remove('is-collapsed');
        return null;
      }
      var needs = text.scrollHeight > text.clientHeight + 1;
      if (!wasCollapsed) text.classList.remove('is-collapsed');
      return needs;
    }

    function sync(root) {
      var text = root.querySelector('[data-collection-description-text]');
      var toggle = root.querySelector('[data-collection-description-toggle]');
      if (!text || !toggle || text.clientWidth === 0) return;

      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      var more = toggle.querySelector('[data-collection-description-more]');
      var less = toggle.querySelector('[data-collection-description-less]');

      if (expanded) {
        text.classList.remove('is-collapsed');
        toggle.hidden = false;
        if (more) more.hidden = true;
        if (less) less.hidden = false;
        return;
      }

      text.classList.add('is-collapsed');
      var needsToggle = overflows(text);
      if (needsToggle === null) return;
      toggle.hidden = !needsToggle;
      if (!needsToggle) text.classList.remove('is-collapsed');
      if (more) more.hidden = false;
      if (less) less.hidden = true;
    }

    function syncAll() {
      document.querySelectorAll('[data-collection-description]').forEach(sync);
    }

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-collection-description-toggle]');
      if (!toggle) return;
      var root = toggle.closest('[data-collection-description]');
      if (!root) return;
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      sync(root);
    });

    window.addEventListener('resize', syncAll);
    window.addEventListener('load', syncAll);
    document.addEventListener('shopify:section:load', syncAll);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncAll);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncAll);
    } else {
      syncAll();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
